import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Header/Header1";
import Footer from "../Footer/footer";
import "./Reward.scss";
import Sidebar from "../SideBar/SideBar";
import Loader from "../Loader";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import tet from "../../Img/tet.svg";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";

export default function Referral() {
  const transaction = [
    {
      icon: tet,
      date: "Follow Our 6 Official Social Media Accounts, Leave a Review on Trustpilot, and Claim 2 USDT!",
      reward: "Reward",
      usdt: "2 USDT",
      left: "Time Left to Complete Task",
      hours: "08 Days  03 Hours  29 Minutes",
    },
    {
      icon: tet,
      date: "Vote for Dreamster-Exchange Coin and Receive 1 USDT Reward",
      reward: "Reward",
      usdt: "2 USDT",
      left: "Time Left to Complete Task",
      hours: "NA",
    },
    {
      icon: tet,
      date: "Invite friends and Earn 2 USDT",
      reward: "Reward",
      usdt: "2 USDT",
      left: "Time Left to Complete Task",
      hours: "NA",
    },
  ];

  const navigate = useNavigate();
  return (
    <div className="spot-full menu-responsive">
      <div>
        <Header />
        <Loader />
        <div className="main_flx">
          <Sidebar />

          <div className="dash_board">
            <div className="abvbar split_half display-2 flex-wrap">
              <h6>Rewards Hub</h6>
              <div className="more-rewards display-1">
                <div className="display-1">
                  <svg
                    width="15"
                    height="17"
                    viewBox="0 0 15 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.88774 12.3257C6.88796 11.5668 7.08643 10.8219 7.46227 10.1695C7.8381 9.51712 8.37742 8.98129 9.02347 8.61839C9.66952 8.25549 10.3984 8.07895 11.1335 8.10734C11.8686 8.13572 12.5827 8.36798 13.2006 8.77969C13.205 8.46689 13.2073 8.1331 13.2073 7.77292C13.2073 5.92102 13.1462 4.7652 13.0256 3.56799H13.0428C12.9761 2.90087 12.7291 2.26647 12.3301 1.73706C11.931 1.20764 11.3959 0.80447 10.7857 0.573466C10.7534 0.560871 10.7212 0.548875 10.6886 0.537478C10.4474 0.453839 10.1981 0.39782 9.94505 0.370433L9.92092 0.367734C8.9556 0.265467 8.80066 0.183594 6.76507 0.183594C4.72948 0.183594 4.40015 0.265467 3.43569 0.369233L3.41156 0.371932C3.14594 0.400713 2.88444 0.461094 2.63227 0.551874V0.538378C2.00349 0.758949 1.44919 1.1609 1.03508 1.69659C0.620976 2.23228 0.364418 2.87925 0.295825 3.56079C0.174904 4.7604 0.113281 5.91742 0.113281 7.77292C0.113281 9.62841 0.174904 10.7854 0.295825 11.985C0.378395 12.8036 0.731331 13.568 1.29542 14.15C1.8595 14.7319 2.60041 15.096 3.39383 15.1811L3.41796 15.1838C4.38329 15.2876 4.53793 15.3694 6.57352 15.3694C7.24788 15.3694 7.73622 15.3604 8.11962 15.3445C7.72918 14.9518 7.419 14.4823 7.20741 13.9638C6.99583 13.4453 6.88713 12.8883 6.88774 12.3257ZM3.48685 4.17679H9.83256C10.0162 4.17679 10.1923 4.25205 10.3222 4.38602C10.452 4.51999 10.5249 4.7017 10.5249 4.89116C10.5249 5.08062 10.452 5.26232 10.3222 5.39629C10.1923 5.53026 10.0162 5.60552 9.83256 5.60552H3.4883C3.30467 5.60552 3.12856 5.53026 2.99871 5.39629C2.86886 5.26232 2.79591 5.08062 2.79591 4.89116C2.79591 4.7017 2.86886 4.51999 2.99871 4.38602C3.12856 4.25205 3.30467 4.17679 3.4883 4.17679H3.48685ZM3.48685 8.66243C3.30563 8.6586 3.13309 8.58163 3.00625 8.44805C2.8794 8.31447 2.80836 8.13492 2.80836 7.94791C2.80836 7.7609 2.8794 7.58135 3.00625 7.44777C3.13309 7.31419 3.30563 7.23722 3.48685 7.23339H7.10603C7.19817 7.23145 7.28976 7.24849 7.37544 7.28352C7.46111 7.31855 7.53915 7.37087 7.60498 7.43741C7.67081 7.50396 7.7231 7.58338 7.75881 7.67104C7.79451 7.7587 7.8129 7.85283 7.8129 7.94791C7.8129 8.04299 7.79451 8.13712 7.75881 8.22478C7.7231 8.31244 7.67081 8.39186 7.60498 8.4584C7.53915 8.52495 7.46111 8.57727 7.37544 8.6123C7.28976 8.64733 7.19817 8.66437 7.10603 8.66243H3.48685Z"
                      fill="#787878"
                    />
                    <path
                      d="M11.3933 9.625C10.7774 9.625 10.1753 9.81343 9.66325 10.1665C9.15116 10.5195 8.75203 11.0213 8.51634 11.6083C8.28065 12.1954 8.21898 12.8414 8.33913 13.4646C8.45929 14.0879 8.75587 14.6604 9.19137 15.1097C9.62687 15.559 10.1817 15.865 10.7858 15.989C11.3898 16.1129 12.016 16.0493 12.585 15.8061C13.154 15.563 13.6403 15.1512 13.9825 14.6228C14.3247 14.0945 14.5073 13.4733 14.5073 12.8379C14.5073 11.9858 14.1792 11.1685 13.5952 10.566C13.0112 9.9635 12.2192 9.625 11.3933 9.625ZM12.6275 13.3081H11.3314C11.2331 13.3081 11.1388 13.2678 11.0693 13.1961C10.9998 13.1244 10.9608 13.0271 10.9608 12.9257V10.8714C10.9608 10.77 10.9998 10.6727 11.0693 10.601C11.1388 10.5293 11.2331 10.489 11.3314 10.489C11.4297 10.489 11.5239 10.5293 11.5934 10.601C11.6629 10.6727 11.702 10.77 11.702 10.8714V12.5433H12.6275C12.7258 12.5433 12.8201 12.5836 12.8896 12.6553C12.9591 12.7271 12.9981 12.8243 12.9981 12.9257C12.9981 13.0271 12.9591 13.1244 12.8896 13.1961C12.8201 13.2678 12.7258 13.3081 12.6275 13.3081Z"
                      fill="#787878"
                    />
                  </svg>
                </div>
                <Button
                  onClick={() => {
                    navigate("/underconstruction");
                  }}
                >
                  {" "}
                  History
                </Button>
              </div>
            </div>

            <div className="crypto-inr split_half">
              <div className="mb-4">
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <h2>OnBoarding tasks</h2>
                    {transaction.map((row) => {
                      return (
                        <div className="offical-acctn display-2">
                          <div className="board-name display-1">
                            <div>
                              <img src={row.icon} />
                            </div>
                            <div>
                              <p>
                                <strong>{row.date}</strong>
                              </p>
                              <Grid container spacing={3} className="grid-top">
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                  <span>{row.reward}</span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                                  <div>
                                    <p>{row.usdt}</p>
                                  </div>
                                </Grid>
                              </Grid>
                              <Grid container spacing={3}>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                  <span>{row.left}</span>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                  <div>
                                    <p>{row.hours}</p>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>
                          </div>

                          <div className="rule-reward">
                            <Stack direction="row" spacing={2}>
                              <Button className="display-1">
                                <DescriptionOutlinedIcon /> Rules
                              </Button>
                              <Button className="display-1 orgn-btn-clr">
                                Claim Rewards <ChevronRightOutlinedIcon />
                              </Button>
                            </Stack>
                          </div>
                        </div>
                      );
                    })}
                  </Grid>
                </Grid>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
}
